<template>
	<div class="moduldBox assessFormWriteModule" v-loading="loading">
		<h4 class="moduldTit">考核评分表{{tableName?`(${tableName})`:''}}</h4>
		<div :class="{'scroll-top':fixation,'form-he':!routeQuery}"
		 :style="{top:(leaderHead && fixation) ? '166px' : leaderHead ? '255px' : ''}"
		 >
			<el-divider content-position="left">基本数据</el-divider>
			<div class="formItem">
				<el-row class="formRow">
					<el-col :span="6">
						<label class="nameTxt">所属部门:</label><span class="valTxt">{{baseInfo.department_name}}</span>
					</el-col>
					<el-col :span="6">
						<label class="nameTxt">考评岗位:</label><span class="valTxt">{{baseInfo.examinee_position}}</span>
					</el-col>
					<el-col :span="8">
						<label class="nameTxt">考评周期:</label><span class="valTxt">{{!!tableName?'':period}}</span>
					</el-col>
				</el-row>
				<el-row class="formRow">
					<el-col :span="6">
						<label class="nameTxt">被考评人:</label><span class="valTxt">{{baseInfo.examinee_name}}</span>
					</el-col>
					<el-col :span="6">
						<label class="nameTxt">被考评人上级:</label><span class="valTxt">{{baseInfo.examinee_leader}}</span>
					</el-col>
					<el-col :span="6">
						<label class="nameTxt">考评人:</label><span class="valTxt">{{baseInfo.examiner_name}}</span>
					</el-col>
				</el-row>
				<el-row class="formRow">
					<el-col :span="6">
						<label class="nameTxt">上月实得绩效总分:</label><span class="valTxt">{{baseInfo.last_month_total_score}}</span>
					</el-col>
					<el-col :span="6">
						<label class="nameTxt">本月最终绩效总分:</label><span class="valTxt">{{baseInfo.total_score}}</span>
					</el-col>
				</el-row>
			</div>
		</div>
		<div :style="!routeQuery && 'padding-top:140px'"></div>
		<el-divider content-position="left">考核内容</el-divider>
		<!-- 考勤 -->
		<div class="formItem contentBox">
			<p class="contentBox-head">考勤(20分)<span class="contentHead-span">总得分 = 实际得分加总 / {{!checkSwitch?'5':'4'}}</span>
				<span v-show="routeQuery"><el-switch v-show="!preview" style="margin-left:20px;" v-model="checkSwitch" ></el-switch> {{!checkSwitch?'日班':'夜班'}}</span>
				<!-- <el-button v-if="isExaminers && buttsele==='个人考核表'" type="primary" size="mini" style="margin-left:20px;" @click="visible=true">组员分数汇总</el-button> -->
			</p>
			<div class="contentBox-body">
				<el-row class="formRow">
					<el-col :span="3"><div>常规考勤(20分)</div></el-col>
					<el-col :span="5"><label class="nameTxt">迟到:</label><span class="valTxt">{{staticData.late_data}}</span>分钟</el-col>
					<el-col :span="5"><label class="nameTxt">事、病假:</label><span class="valTxt">{{staticData.ask_for_leave_data}}</span>小时</el-col>
					<el-col :span="5"><label class="nameTxt">早退:</label><span class="valTxt">{{staticData.leave_early_data}}</span>分钟</el-col>
					<el-col :span="5">
						<label class="nameTxt">实际得分:</label>
						<span class="valTxt">{{staticData.regular_attendance_score || ''}}</span>
						<el-tooltip class="item" effect="dark" content="计算标准: (实际出勤分钟数/当月应出勤分钟数)% * 20" placement="right">
							<i class="el-icon-question"></i>
						</el-tooltip>
					</el-col>
				</el-row>
				<el-row class="formRow">
					<el-col :span="6"><label class="nameTxt">9分钟(20分):</label><span class="valTxt">{{staticData.nine_minute_times_data}}</span>次</el-col>
					<el-col :span="6">
						<label class="nameTxt">实际得分:</label>
						<span class="valTxt">{{staticData.nine_minute_times_score || ''}}</span>
						<el-tooltip class="item" effect="dark" content="计算标准: (1 - (次数/应出勤天数))% * 20" placement="right">
							<i class="el-icon-question"></i>
						</el-tooltip>
					</el-col>
				</el-row>
				<el-row class="formRow">
					<el-col :span="6"><label class="nameTxt">漏打卡(20分):</label><span class="valTxt">{{staticData.missing_clock_in_data}}</span>次</el-col>
					<el-col :span="6">
						<label class="nameTxt">实际得分:</label>
						<span class="valTxt">{{staticData.missing_clock_in_score || ''}}</span>
						<el-tooltip class="item" effect="dark" content="计算标准: 0-2次得20分,超过2次后每次少一分" placement="right">
							<i class="el-icon-question"></i>
						</el-tooltip>
					</el-col>
				</el-row>
				<el-row class="formRow">
					<el-col :span="6"><label class="nameTxt">{{!checkSwitch?'早餐':'宵夜'}}超时(20分):</label><span class="valTxt">{{staticData.meal_overtime_data}}</span>分钟</el-col>
					<el-col :span="6">
						<label class="nameTxt">实际得分:</label>
						<span class="valTxt">{{staticData.meal_overtime_score || ''}}</span>
						<el-tooltip class="item" effect="dark" content="计算标准: 分10级,每3分钟一级,一级2分" placement="right">
							<i class="el-icon-question"></i>
						</el-tooltip>
					</el-col>
				</el-row>
				<el-row class="formRow" v-show="!checkSwitch">
					<el-col :span="6"><label class="nameTxt">午餐超时(20分):</label><span class="valTxt">{{staticData.lunch_overtime_data}}</span>分钟</el-col>
					<el-col :span="6">
						<label class="nameTxt">实际得分:</label>
						<span class="valTxt">{{staticData.lunch_overtime_score || ''}}</span>
						<el-tooltip class="item" effect="dark" content="计算标准: 分10级,每6分钟一级,一级2分" placement="right">
							<i class="el-icon-question"></i>
						</el-tooltip>
					</el-col>
				</el-row>
			</div>
			<p class="contentBox-foot">
				<el-row>
					<el-col :span="12">
						<div>总分:<span class="totalTxt">
							{{setAllScore([staticData.regular_attendance_score,staticData.nine_minute_times_score,staticData.missing_clock_in_score,staticData.meal_overtime_score,staticData.lunch_overtime_score],0)}}
						</span>
						</div>
					</el-col>
				</el-row>
			</p>
		</div>
		<!-- 时间管理 -->
		<div class="formItem contentBox">
			<p class="contentBox-head">时间管理(5分)<span class="contentHead-span">总得分 = 实际得分加总</span></p>
			<div class="contentBox-body">
				<el-row class="formRow">
					<el-col :span="6"><label class="nameTxt">下班计划(5分):</label><span class="valTxt">{{staticData.off_plan_overtime_data}}</span>次</el-col>
					<el-col :span="6">
						<label class="nameTxt">实际得分:</label>
						<span class="valTxt">{{!routeQuery ? (staticData.off_plan_overtime_score || '0') : ''}}</span>
						<el-tooltip class="item" effect="dark" content="计算标准: 0-5次得5分,超过5次后每次少1分" placement="right">
							<i class="el-icon-question"></i>
						</el-tooltip>
					</el-col>
				</el-row>
				<el-row class="formRow">
					<el-col :span="6"><label class="nameTxt">早餐计划(0分):</label><span class="valTxt">{{staticData.breakfast_plan_data}}</span>次</el-col>
					<el-col :span="6">
						<label class="nameTxt">实际得分:</label>
						<span class="valTxt">{{!routeQuery ? (staticData.breakfast_plan_score || '0') : ''}}</span>
						<el-tooltip class="item" effect="dark" content="计算标准: 不计分,仅作参考" placement="right">
							<i class="el-icon-question"></i>
						</el-tooltip>
					</el-col>
				</el-row>
				<el-row class="formRow">
					<el-col :span="6"><label class="nameTxt">午餐计划(0分):</label><span class="valTxt">{{staticData.lunch_plan_data}}</span>次</el-col>
					<el-col :span="6">
						<label class="nameTxt">实际得分:</label>
						<span class="valTxt">{{!routeQuery ? (staticData.lunch_plan_score || '0') : ''}}</span>
						<el-tooltip class="item" effect="dark" content="计算标准: 不计分,仅作参考" placement="right">
							<i class="el-icon-question"></i>
						</el-tooltip>
					</el-col>
				</el-row>
			</div>
			<p class="contentBox-foot">
				<el-row>
					<!-- <el-col :span="12"><div class="nameTxt">总得分 = 实际得分加总</div></el-col> -->
					<el-col :span="12">
						<div>总分: 
							<span class="totalTxt">{{setAllScore([staticData.off_plan_overtime_score,staticData.breakfast_plan_score,staticData.lunch_plan_score],1)}}</span>
						</div></el-col>
				</el-row>
			</p>
		</div>
		<!-- 自定义 -->
		<custom v-if="routeQuery" ref="custom" :preview="preview" :checkSwitch="checkSwitch" @setShift="setShift"></custom>
		<assessCustommModu v-if="!routeQuery" :data="customData" :myTeam="myTeam" :isExaminers="isExaminers" :buttsele="buttsele" @visibleChange="(v) => visible = v" ref="assessCustom"></assessCustommModu>
		<!-- 追加项 -->
		<div class="formItem contentBox">
			<p class="contentBox-head">追加项(5分)</p>
			<div class="contentBox-body" style="padding: 10px;">
				<p>申请理由: </p>
				<el-input class="assess-input" :disabled="!isRole.includes(1) || (isRole.includes(3) && isExaminer) || isConfirmed" type="textarea" :autosize="{ minRows: 2}" v-model="staticData.additional_reason"></el-input>
			</div>
			<div class="contentBox-body" style="padding: 10px;border-top:0;">
				<p>考评人追加项意见: </p>
				<el-input class="assess-input" :disabled="!isRole.includes(2) || (isRole.includes(3) && isExaminer) || isConfirmed" type="textarea" :autosize="{ minRows: 2}" v-model="staticData.additional_examiner_comment"></el-input>
			</div>
			<div class="contentBox-foot">
				<p>部门负责人追加项意见: </p>
				<el-input class="assess-input" type="textarea" :autosize="{ minRows: 2}" v-model="staticData.additional_leader_comment" placeholder="" :disabled="!isRole.includes(3) || isConfirmeds" ></el-input>
				<div style="margin-top:10px;">
					<label>部门负责人追加项评分: </label>
					<span><el-input type="number" class="assess-input" v-model="staticData.additional_item" placeholder="" :disabled="!isRole.includes(3) || isConfirmeds" size="mini" style="width: 200px;"></el-input></span>
				</div>
			</div>
		</div>
		<!-- 总结与建议 -->
		<el-form :model="staticData" ref="conclusion" class="demo-ruleForm">
			<div class="formItem contentBox">
				<p class="contentBox-head">总结与建议</p>
				<div class="contentBox-body" style="padding: 0 10px 10px;">
					<el-form-item
						class="assess-input"
					 	label-width="40" 
						prop="examinee_summary"
						label="被考评人总结与改进"
						:rules="{ required: !(!isRole.includes(1) || (isRole.includes(3) && isExaminer) || isConfirmed), message: '请输入被考评人总结与改进', trigger: 'blur' }"
					>
						<el-input type="textarea" :autosize="{ minRows: 2}" size="mini" :disabled="!isRole.includes(1) || (isRole.includes(3) && isExaminer) || isConfirmed" v-model="staticData.examinee_summary"></el-input>
					</el-form-item>
					<el-form-item
						class="assess-input"
					 	label-width="40" 
						prop="examiner_comment"
						label="考评人意见"
						:rules="{ required: !(!isRole.includes(2) || (isRole.includes(3) && isExaminer)  || isConfirmed), message: '请输入考评人意见', trigger: 'blur' }"
					>
					<el-input type="textarea" :autosize="{ minRows: 2}" size="mini" :disabled="!isRole.includes(2) || (isRole.includes(3) && isExaminer) || isConfirmed" v-model="staticData.examiner_comment"></el-input>
					</el-form-item>
					<el-form-item
						class="assess-input"
					 	label-width="40"
						prop="leader_comment"
						label="部门负责人意见"
						:rules="{ required: !(!isRole.includes(3) || isConfirmeds), message: '请输入部门负责人意见', trigger: 'blur' }"
					>
						<el-input type="textarea" :autosize="{ minRows: 2}" size="mini" :disabled="!isRole.includes(3) || isConfirmeds" v-model="staticData.leader_comment"></el-input>
					</el-form-item>
				</div>
			</div>
		</el-form>
		<!-- 确认 -->
		<div style="padding: 20px 0;clear: both; text-align: center;">
			<el-button type="primary" v-show="isRole.includes(2) || isRole.includes(3) || (isCheck && !isRole.includes(1))" @click="backClick('组别/组员')"  size="mini">返回</el-button>
			<el-button type="primary" v-show="routeQuery" @click="previewClick"  size="mini">{{preview?'返回编辑':'预览'}}</el-button>
			<el-button v-show="!routeQuery && !isConfirmed && !isCheck && !isConfirmeds" type="primary" @click="saveData" size="mini">保存</el-button>
			<el-button v-show="!preview && !isConfirmed && !isCheck && !isConfirmeds" type="primary" :loading="submitLoading" @click="submitData" size="mini">{{routeQuery?'保存':'提交'}}</el-button>
		</div>
		<!-- 奖金说明 -->
		<div class="formFoot">
			<p>考评周期当月所得的应发奖金补贴将跟根据最终的总分计算: </p>
			<p style="text-indent: 2em;">最终总分 ≥ 95分,可得100%应发奖金补贴;</p>
			<p style="text-indent: 2em;">95分 > 最终总分 ≥ 90,可得90%应发奖金补贴;</p>
			<p style="text-indent: 2em;">90分 > 最终总分 ≥ 85,可得80%应发奖金补贴;</p>
			<p style="text-indent: 2em;">85分 > 最终总分 ≥ 80,可得70%应发奖金补贴;</p>
			<p style="text-indent: 2em;">80分 > 最终总分,可得50%应发奖金补贴;</p>
			<p>* 当完成个人填写部分，点击"提交"后，所填写的信息将不能再修改。</p>
		</div>
		<summarizing :visible="visible" :groupAssessmentList="groupAssessmentList" @close="visible=!visible"></summarizing>
	</div>
</template>
<script>
import custom from '@/page/assessFormSetting/CustomAssess'
import assessCustommModu from '@/page/assessFormSetting/assessCustommModu'
import { tableSeleType } from '@/assets/js/message.js'
import { computeAssessDate } from '@/assets/js/date.js'
import summarizing from './components/summarizing'
export default {
	data(){
		return {
			date:'',					//日期：本期，下期
			tableName: '',
			baseInfo: {},
			loading:false,
			routeQuery:'',				// url参数
			preview:false,          	//预览
			staticData:{},				//基础数据
			customData:[],				//自定义数据
			isConfirmed:false,			//被考评人是否已提交
			isConfirmeds:false,			//是否已提交
			isExaminer:false,
			staff_id:'',
			submitLoading:false,
			allScore:[],				//总分
			myTeam:'',					//管理能力下的全组成绩数据
			checkSwitch:false,			//模板考勤是否显示
			period:'',					//周期
			fixation:false,				//头部固定
			leaderHead:false,
			visible:false,				//汇总
			groupAssessmentList: []		//组员分数汇总
		}
	},
	props:['isRole','isCheck','isExaminers','buttsele'],
	created(){
		this.date=computeAssessDate();
		if(JSON.stringify(this.$route.query) !== '{}'){
			this.routeQuery=this.$route.query;
			this.tableName=this.$route.query.formName;
		}
	},
	methods:{
		initData(data,url){	//初始渲染数据；url?staff_id:assessment_id
			// this.loading=true;
			this.staff_id=data.staff_id;
			// this.period=`${data.start}/${data.end}`;
			this.calculateByStaff(data,url);	//计算
		},
		getInitData(data,url){			//获得考核表
			this.period=`${data.start}/${data.end}`;
			this.$http.get(url?url:'assessment/getOne',{params:data}).then((v)=>{
				if(v.status === 200){
					if(this.$store.state.login.userinfo.id != v.data.data.base.examiner_id){	//登录用户是否为该考核表的负责人不为考评人
						this.isExaminer=true;
					}else{
						this.isExaminer=false;
					}
					if(this.isRole.includes(1) && this.isRole.length==1 && v.data.data.static.is_examinee_confirmed==1){//被考评人是否已填表
						this.isConfirmed=true;	
					}else{
						this.isConfirmed=false;
					}
					if(this.isRole.includes(2) && !this.isRole.includes(3) && v.data.data.static.is_examiner_confirmed==1){//考评人是否已填表
						this.isConfirmed=true;
					}
					if(v.data.data.static.is_leader_confirmed==1){	//负责人是否提交
						this.isConfirmeds=true;
					}else{
						this.isConfirmeds=false;
					}
					if(this.isRole.includes(1) && this.isCheck){		//负责人查看
						this.isConfirmed=true;	
					}
					if(this.isConfirmeds && this.isRole.includes(3)){		//负责人操作，考核表已提交
						this.isConfirmed=true;
					}
					this.$emit('attendanceChang',v.data.data.base.is_attendance);
					v.data.data.myTeam && (this.myTeam=v.data.data.myTeam);
					this.checkSwitch=v.data.data.base.shift === 1 ? true : false;	//true夜班；false日班
					this.baseInfo=v.data.data.base;
					this.staticData=v.data.data.static;
					const { custom } = v.data.data;
					const sortArr=['工作达成',"工作能力","管理能力"];
					const customArr=[];
					sortArr.forEach((item)=>{
						customArr.push(this.setCustomData(custom).find(v=>v.name===item))
					})
					this.customData=customArr;
					if (this.buttsele === '个人考核表') {
						this.getAssessmentListByStaff(data)
					}
				}
				this.loading=false;
			}).catch((er)=>{this.loading=false;})
		},
		calculateByStaff(data,url){		//计算考核表
			this.$refs['conclusion'].resetFields() //重置表单
			this.$refs.assessCustom.resetForm()
			this.$http.get(url?'score/calculateByStaff':'score/calculate',{params:data}).then(v=>{
				if(v.status === 200 && !v.data.status)	this.$message({message:v.data.message,type:'error'});
				this.getInitData(data,url)
			}).catch(v=>{})
		},
		getAssessmentListByStaff (data) {
			const params = {
				start: data.start,
				end: data.end,
				staff_id: this.staff_id
			}
			this.$http.get('assessment/getAssessmentListByStaff',{params}).then(v=>{
				if(v.status === 200 && v.data.status) {
					let arr = []
					for (let i in v.data.data) {
						arr.push(...v.data.data[i])
					}
					this.groupAssessmentList = arr
				}
			}).catch(v=>{})
		},
		setCustomData(params){				//自定义数据处理
            let cloneData = JSON.parse(JSON.stringify(params));
            return cloneData.filter((father,index)=>{               
                let branchArr = cloneData.filter(child=>father.id == child.parent_id)    //返回每一项的子级数组
                if(father.logic_type == '1')  father.seleData=this.setSeleData(father,index);
                father.name=father.item_name;
                if(father.parent_id ==  "00000000-0000-0000-0000-000000000000" ){
                    father.parent_id='0';
                    father.childs=[];
                }
                branchArr.length>0 ? father.childs = branchArr : '';
                return father.parent_id=="0";
            });
		},
		setSeleData(v,index){		//评论类型数据
            const assess_type=v.assess_type.split(',');
            const assess_percentage=v.assess_percentage.split(',');
			let param=[];
            assess_type.forEach((item)=>{
				let data='';
				tableSeleType.forEach(t=>{
					if(t.value==item){
						param.push({
							assess:v.score_storage?JSON.parse(v.score_storage)[t.value]:'',
							disabled: this.isConfirmed || (this.isRole.includes(3) && this.isExaminer) || t.value == 2 || t.value == 4 || t.value == 5 || (t.value ==1 && !this.isRole.includes(1)) || (t.value ==3 && !this.isRole.includes(2)),
							...t,
						});
						
					}
				})
			})
            return param;
        },
		submitData(){
			if(this.routeQuery){				//自定义编辑保存
				let param=this.$refs.custom.subClick();
				param.template_id=this.routeQuery.formId;
				param.shift=this.checkSwitch ? 1 : 0;
				this.submitLoading=true;
				this.$http.post('template/createCustom',param).then((v)=>{
					this.submitLoading=false;
					if(v.status === 200){
						this.$message({message:v.data.message,type:'success'});
						this.$router.go(-1);
					}
				}).catch((v)=>{this.submitLoading=false;})
			}else{			//提交
				this.saveData(true)
			}
		},
		submitSaveData(data,isSub){		//保存，提交
			this.$http.post('/assessment/saveAssessment',data).then((v)=>{	//保存
				if(v.status === 200){
					let param={
							start:computeAssessDate()[0].split('/')[0],
							end:computeAssessDate()[0].split('/')[1],
							staff_id:this.$store.state.login.userinfo.id,
						};
					if(isSub!=true){
						this.$message({message:v.data.message,type:'success'});
						param.staff_id=this.staff_id;
						this.initData(param,'/assessment/getOneByStaff')
						this.$emit('historical'); //往期数据
					}
					isSub===true && (this.submitLoading=true);
					isSub===true && this.$http.put('/assessment/confirm',{		//提交
							params:param,
							assessment_id:data.assessment_id,
							type:data.type,
						}).then(v=>{
							if(v.status === 200){
								param.staff_id=this.staff_id;
								this.$message({message:v.data.message,type:'success'});
								this.initData(param,'/assessment/getOneByStaff');
								this.$emit('historical'); //往期数据
								if(this.isRole.includes(2) || this.isRole.includes(3)){				//考评人或负责人重新获取组员的状态
									this.$emit('getAssessmentList',{...param,staff_id:this.$store.state.login.userinfo.id})
								}
							}
							this.submitLoading=false;
						}).catch(()=>{this.submitLoading=false;})
				}
			}).catch((v)=>{this.submitLoading=false;})
		},
		isAllMyExamineeCompleted(data,isSub){		//考评人填写个人考核表:判断该考核评分表的组员是否已经全部提交完毕
			if(this.isRole.includes(1) && this.isExaminers && isSub==true){
				this.submitLoading=true;
				this.$http.get('assessment/isAllMyExamineeCompleted',{params:{
					start:computeAssessDate()[0].split('/')[0],
                    end:computeAssessDate()[0].split('/')[1],
                    staff_id:this.$store.state.login.userinfo.id,
				}}).then(v=>{
					if(v.status === 200 ) v.data.status?this.submitSaveData(data,isSub):this.$message({message:v.data.message,type:'error'});
					if(!v.data.status) this.submitLoading=false;
				}).catch(r=>{this.submitLoading=false;})
			}else{
				this.submitSaveData(data,isSub)
			}
		},
		saveData(isSub=''){		//保存
			let data={
				data:'',
				assessment_id:'',
				type:'1',
			}
			let params={
				custom_ids:'',
				custom_scores:'',
			}
			let message='';
			this.customData.forEach((p)=>{
				p.childs && p.childs.forEach((t,index)=>{
					if(t.logic_type == '1' && !t.childs){		//获得项目自评
						let strs=params.custom_ids?',':'';
						params.custom_ids+=strs+t.id;
						params.custom_scores+=strs+this.setSaveData(t);
						data.assessment_id=t.assessment_id;
						if(this.setSaveData(t) && this.setSaveData(t)>t.max_score && !(t.assess_type==1 && t.static_logic ==1 && t.logic_type == 1)){
							message='请按要求填写分数';
						}
					}
					t.childs && t.childs.forEach((v,i)=>{	//模块下项目自评
						if(v.logic_type == '1' && !v.childs){
							let str=params.custom_ids?',':'';
							params.custom_ids+=str+v.id;
							params.custom_scores+=str+this.setSaveData(v);
							data.assessment_id=t.assessment_id;
							if(this.setSaveData(v) && this.setSaveData(v)>v.max_score && !(v.assess_type==1 && v.static_logic ==1 && v.logic_type == 1)){
								message='请按要求填写分数'
							}
						}
					})
				})
			})
			if(this.isRole.includes(1) && this.baseInfo.examinee_id === this.$store.state.login.userinfo.id) { //被考评人;添加被考评人判断，避免非被考评人走表单验证
				params.examinee_summary=this.staticData.examinee_summary;
				params.additional_reason=this.staticData.additional_reason || '';
				data.type='1';
				if(params.custom_scores.includes(',,') || params.custom_scores.substring(0,1) ===',' || params.custom_scores.substring(params.custom_scores.length,params.custom_scores.length-1) === ','){
					message='请填写自评！'
				}else if(!params.examinee_summary){
					message='请填写被考评人总结与改进!';
				}
			}
			if(this.isRole.includes(2) && !this.isRole.includes(3)){		//考评人
				params.examiner_comment=this.staticData.examiner_comment;
				params.additional_examiner_comment=this.staticData.additional_examiner_comment || '';
				data.type='2';
				if(params.custom_scores.includes(',,')  || params.custom_scores.substring(0,1) ===',' || params.custom_scores.substring(params.custom_scores.length,params.custom_scores.length-1) === ','){
					message='请填写考评人评！'
				}else if(!params.examiner_comment){
					message='请填写考评人意见!';
				}
			}
			if(this.isRole.includes(3) && this.isExaminer){					//负责人
				params={
					leader_comment:this.staticData.leader_comment,
					additional_item:this.staticData.additional_item || '',
					additional_leader_comment:this.staticData.additional_leader_comment || '',
				}
				data.type='3';
				if(!params.leader_comment){
					message='请填写部门负责人意见！'
				}
			}
			if(this.isRole.includes(2) && this.isRole.includes(3) && this.isRole.length===2 && !this.isExaminer){					//考评人，负责人
				params.examiner_comment=this.staticData.examiner_comment;
				params.additional_examiner_comment=this.staticData.additional_examiner_comment || '';
				params.leader_comment=this.staticData.leader_comment,
				params.additional_item=this.staticData.additional_item || '',
				params.additional_leader_comment=this.staticData.additional_leader_comment || '',
				params.additional_reason='',
				data.type='4';
				if(params.custom_scores.includes(',,')  || params.custom_scores.substring(0,1) ===',' ||  params.custom_scores.substring(params.custom_scores.length,params.custom_scores.length-1) === ','){
					message='请填写考评人评！'
				}else if(!params.examiner_comment){
					message='请填写考评人意见!';
				}else if(!params.leader_comment){
					message='请填写部门负责人意见！'
				}
			}
			if (this.staticData.additional_item && this.staticData.additional_item > 5) {
				message='追加项评分不可以高于5分！'
			}
			if (params.custom_scores) {
				params.custom_scores=params.custom_scores.replace(new RegExp('&','g'),'') //不计算类型处理
			}
			data.data=JSON.stringify(params);
			this.$refs.conclusion.validate((valid) => {
				if (!valid || !this.$refs.assessCustom.submitForm()) message = '请按要求填写分数！';
				if(message) {
					this.$message({message,type:'error'}); //错误限制提交
					return
				}
				if (valid && this.$refs.assessCustom.submitForm() && !message) {
					this.isAllMyExamineeCompleted(data,isSub)
				}
			});
		},
		setSaveData(data){
			let params='';
			if(this.isRole.includes(1) || this.isRole.includes(2)){
				data.seleData.forEach((v)=>{
					if((v.value == 3 && this.isRole.includes(2) && !this.isRole.includes(1)) || v.value == 1){
						if (data.assess_type == '1') { // //不计算类型处理验证问题
							params=!isNaN(v.assess) && v.assess!=''?v.assess:'&'
						} else {
							params=!isNaN(v.assess)?v.assess:''
						}
						
					} else if (v.value == 3 && params === '' && this.isRole.length === 1 && this.isRole.includes(1)) {
						params=!isNaN(v.assess)?v.assess:''
					}
				})
			}
			return params
		},
		setAllScore(data,index){
			let param=0;
			data.map((v,i)=>{
				if(v){
					if(index === 0 && this.checkSwitch && data.length === (i+1)){				//夜班计算前4个
						return false;
					}
					param+=Number(v)
				};
			})
			if(index === 0){
				if(this.checkSwitch){
					param/=4
				}else{
					param/=5
				}
			};
			this.allScore[index]=param;
			
			return !this.tableName ? param.toFixed(2) : '';
		},
		//设置日夜班
		setShift(v){
			this.checkSwitch=v;
		},
		previewClick(){		//预览滚动到指定位置
			this.preview=!this.preview;
			this.$store.commit('setScrollTop',this.preview);
		},
		backClick(v){	//返回
			this.$emit('buttonClick',v)
		},
		//固定头部
		contentScroll(is){
			this.fixation = is;
		},
		setLeaderHead(is){
			this.leaderHead = is;
		}
	},
	components:{
        custom,assessCustommModu,summarizing
    }
}
</script>
<style scoped>
.assessFormWriteModule {
	width: 1100px;
}
.assessFormWriteModuleBox{
	background: #fff;
	overflow: auto;
	height: 100%;
}
.formItem {
	padding: 0 20px;
	font-size: 14px;
	line-height: 20px;
}
.formItem .formRow {
	margin: 10px 0;
}
.formRow .nameTxt {
	display: inline-block;
	margin-right: 8px;
}
.formRow .valTxt ,.totalTxt{
	min-width: 80px; 
	display: inline-block;
	border-bottom: 1px solid #333;
}
.contentBox {
	padding: 0 10px;
	margin-bottom: 10px;
}
.contentBox .formRow {
	margin: 16px 0;
}
.contentBox .contentBox-head{
	padding: 10px;
	font-weight: bold;
	border: 1px solid #DCDFE6;
	border-bottom-width: 0;
	border-radius: 6px 6px 0 0;
}
.contentBox-head .contentHead-span {
	display: inline-block;
	margin-left: 10px;
}
.contentBox .contentBox-body{
	padding: 0px 10px;
	border: 1px solid #DCDFE6;
}
.contentBox .contentBox-foot{
	padding: 10px;
	font-weight: bold;
	border: 1px solid #DCDFE6;
	border-top-width: 0;
}
.formFoot {
	margin: 10px;
	padding: 10px;
	border: 1px solid #DCDFE6;
	font-size: 14px;
	line-height: 20px;
}
.form-he{
	position: fixed;
	background: #ffffff;
	width: 1100px;
	height: 141px;
	top: 200px;
	z-index: 10;
}
.scroll-top{
	box-shadow: 0px 3px 6px rgba(51,51,51,0.1);
    top: 110px;
	padding-bottom: 20px;
}
</style>


